import { refreshConnectedAccountAccessToken } from '../services/refreshConnectedAccountAccessToken';
import { ConnectedAccountResponse } from '../contracts/ConnectedAccountResponse';
import { ErrorResponse } from '../contracts/ErrorResponse';

export async function getAccessToken(
    id: string
): Promise<ConnectedAccountResponse | ErrorResponse> {
    return await refreshConnectedAccountAccessToken(id);
    // to do: error handling
}
